
import {
  Dropdown,
  Button as ThemesbergButton,
} from "@themesberg/react-bootstrap";
import React, { useState, useMemo, useCallback, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';



const useTableCustom = (
  data = [],
  columns,
  isManualPagination = false,
  onChangePagination = () => { },
  customPageSize = 10,
  totalPageCount = 1,
  isLoading = false,
  columnType = "",
  isShowColSettings = true,
  tableKey = "demo_table"
) => {

  const dropdownRef = useRef(null);

  // const getStoredColumns = () => {
  //   const storedData = localStorage.getItem(`${tableKey}_cols_visibility`);

  //   if (storedData) return JSON.parse(storedData);

  //   return columns?.reduce((acc, column) => {
  //     acc[column.Header] = true;
  //     return acc;
  //   }, {});
  // };

  const getStoredColumns = () => {
    const storedData = localStorage.getItem(`${tableKey}_cols_visibility`);
    const saved = storedData ? JSON.parse(storedData) : {};
  
    // Always merge with latest columns list
    const merged = columns?.reduce((acc, column) => {
      // If column is already stored, keep its state
      // Otherwise default to true
      acc[column.Header] = saved[column.Header] ?? true;
      return acc;
    }, {});
  
    return merged;
  };

  

  const [filteredColumns, setFilteredColumns] = useState(getStoredColumns);
  const [isOpen, setIsOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);


  useEffect(() => {
    if (filteredColumns) {

      localStorage.setItem(
        `${tableKey}_cols_visibility`,
        JSON.stringify(filteredColumns)
      );
    }

  }, [filteredColumns, tableKey]);


  const tableHeaderClass = useSelector(
    (state) => state.Layout?.tableHeaderClass || ""
  );

  const visibleColumns = useMemo(() => {
    if (!isShowColSettings) return columns;
    return columns.filter((col) => filteredColumns[col.Header]);
  }, [columns, filteredColumns, isShowColSettings]);

  const pageData = useMemo(() => {
    if (isManualPagination) return data;
    const start = currentPage * customPageSize;
    return data.slice(start, start + customPageSize);
  }, [data, currentPage, customPageSize, isManualPagination]);

  const handlePagination = (newPage) => {
    setCurrentPage(newPage?.selected || 0);
    if (isManualPagination) {
      onChangePagination((newPage?.selected || 0) + 1);
    }
  };

  const noDataFound = !isLoading && pageData.length === 0;

  const handleColumnHide = useCallback((header) => {
    setFilteredColumns((prevState) => ({
      ...prevState,
      [header]: !prevState[header],
    }));
  }, []);


  const resetColumns = () => {
    const reset = columns?.reduce((acc, col) => {
      acc[col.Header] = true;
      return acc;
    }, {});
    setFilteredColumns(reset);
  };

  // return {

  // };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const customColSetting = (

    <Dropdown
      className="position-relative w-100 custom-toggle"
      show={isOpen}
      ref={dropdownRef}
      onToggle={(nextShow) => setIsOpen(nextShow)}
    >
      <Dropdown.Toggle
        id="dropdown-basic"
        className="btn-sm d-flex align-items-center justify-content-between gap-2 border border-primary custom-toggle w-100 bg-white text-dark"
        style={{ minWidth: '200px' }}
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
      >
        <span>Columns</span>
        <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="p-2"
        align="end"
        style={{ width: '100%', minWidth: '200px' }}
      >
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {columns
            .filter(({ Header }) => typeof Header === "string")
            .map((column) => (
              <div
                key={column.accessor}
                className="d-flex align-items-center"
                style={{ cursor: "pointer", gap: '10px' }}
              >
                <input
                  type="checkbox"
                  checked={filteredColumns[column.Header]}
                  onChange={() => handleColumnHide(column.Header)}
                />
                <p className="m-0">{column.label || column.Header}</p>
              </div>
            ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>



  );
  return {
    visibleColumns,
    pageData,
    tableHeaderClass,
    handlePagination,
    customColSetting,
    noDataFound,
    resetColumns
  };
};

export default useTableCustom;
